module.exports = __webpack_public_path__ + "img/def-hotel.799d75f5.jpg";